import React, {useEffect, useState} from 'react';
import { Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination,  } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";

interface PricePerSqFtModalProps {
    details?: BlackoutDate;
    year: number;
    show: boolean;
    toggle: () => void;
}

interface BlackoutDate {
    date: string;
    name: string;
    blackoutDateId: string;
}


const BlackoutDatesModal: React.FC<PricePerSqFtModalProps> = ({details, year, show, toggle}) => {
    const [date, setDate] = useState<string>(null);
    const [name, setName] = useState<string>('');
    const [showErrors, setShowErrors] = useState(false);

    function handleSave() {
        let postData = {
            date: date,
            name: name,
            ...(details ? { blackoutDateId: details.blackoutDateId } : {}),
        }
        if(details){
            businessYearService.updateBlackoutDate(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_BLACKOUT)
                toggle();
            })
        } else {
            businessYearService.createBlackoutDate(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_BLACKOUT)
                toggle();
            })
        }
        
    }
    useEffect(() => {
        if(details){
            setDate(details.date);
            setName(details.name);
        } else {
            setDate(null);
            setName('');
        }
        
    }, [details]);
    
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">Blackout Date</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="Name" className="col-md-6 mb-3">
                            <FormControl
                                type="text"
                                label={"Name"}
                                value={name}
                                placeholder='Date Name'
                                showErrors={showErrors}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="date" className="col-md-6 mb-3">
                            <Form.Label>Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={date}             
                                onChange={(e) => setDate(e.target.value)}
                                placeholder="Select a date"
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BlackoutDatesModal;
